import { ConversationBase } from '../../conversations/common/models/conversation-base.model';
import { UserPermission } from '../../users/models/user-permission.enum';
import { WorkItemIntegration } from './work-item-integrations.model';

export const journeyIntegration: WorkItemIntegration = {
  id: 'journey',
  svgIconName: 'genesys-journey',
  tooltip: 'tooltips.gcJourneyIntegration',
  title: 'tooltips.gcJourneyIntegration',
  parseUrl: (conversation: ConversationBase, gcDomain: string, locale: string): string => {
    const externalContactId = conversation.customerParticipant.externalContactId;

    return `https://apps.${gcDomain}/journey-micro/gpe-ui-holistic-customer-journey/?` +
      `gadgetId=holisticCustomerJourney&locale=${locale.toLocaleLowerCase()}&externalContactId=${externalContactId}`;
  },
  permissions: [UserPermission.JourneyEventView, UserPermission.ExternalContactsSessionView]
};
